import { getFileSrc } from '@/utils/utilities';
import { Loader } from '../utils/Loader';
import { Texture, MeshStandardMaterial, Group, Object3DEventMap } from 'three';
import { RenderUtils } from './RenderUtils';
import { PredefinedMaterialFactory } from './PredefinedMaterialFactory';
import { UserDataProp } from '../types';

export class AssetsLib {
	private loader = Loader.getInstance();
	private predefinedMaterialFactory = PredefinedMaterialFactory.getInstance();
	texturesCache = new Map<string, Texture>();
	materialCache = new Map<string, MeshStandardMaterial>();
	models = new Map<string, Group<Object3DEventMap>>();

	private static instance: AssetsLib;

	private constructor() {}

	static getInstance() {
		if (!AssetsLib.instance) AssetsLib.instance = new AssetsLib();
		return AssetsLib.instance;
	}

	async loadModel(path: string) {
		const fileType = path.split('.').pop();

		switch (fileType) {
			case 'glb':
			case 'gltf':
				const gltf = await this.loader.gltfLoader.loadAsync(getFileSrc(path));

				const clone = gltf.scene.clone();
				this.loadPredefinedMaterials(clone);

				this.models.set(path, clone);
				return clone;
			case 'fbx':
				const group = await this.loader.FBXLoader.loadAsync(getFileSrc(path));
				this.models.set(path, group);
				return group.clone();

			default:
				throw new Error('UNSUPPORTED_MODEL_TYPE');
		}
	}

	private loadPredefinedMaterials(scene: Group<Object3DEventMap>) {
		scene.traverse((child) => {
			if (!RenderUtils.isMesh(child)) return;
			if (!child.userData[UserDataProp.PREDEFINED_MATERIAL]) return;

			const material = this.predefinedMaterialFactory.getMaterial(
				child.userData[UserDataProp.PREDEFINED_MATERIAL]
			);

			child.material = material;
		});
	}
}
